import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-navy" data-id="element-21" data-mp="pio8yn0kl492">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-22" data-mp="avl8q8kv4hi1">
        <div className="text-center" data-id="element-23" data-mp="at8v27m50tas">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-24" data-mp="fteh989n1nlh">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-25" data-mp="1t3ou0sok0y7">
            Five instant-use <span className="text-gold" data-id="element-26" data-mp="3o2mz1kkfrgcs">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-27" data-mp="3t0g4uchtu8cj">
            The volumes give you the season. These five handle the parts around
            it — the first-timer, the sideline, the parents and the kids who
            tune out.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-28" data-mp="1r6z1hl0qbtnl">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-navy-line bg-navy-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-29" data-mp="3ic3i65mj8udr" data-mpi={i}>
              <div className={`flex items-center justify-between px-5 py-4 ${bonus.tag}`} data-id="element-30" data-mp="2zf2b8f9f4k76">
                <span className="font-display text-4xl leading-none text-white/90" data-id="element-31" data-mp="2uhiu97lc5tbj">
                  {bonus.number}
                </span>
                <GiftIcon className="h-6 w-6 text-white/90" aria-hidden="true" data-id="element-32" data-mp="38dw2dq3zcidc" />
              </div>
              <div className="aspect-[4/3] w-full overflow-hidden bg-navy-mid" data-id="element-33" data-mp="33jies9vk7fj8">
                <img src={bonus.image} alt={`Mockup de ${bonus.title}`} loading="lazy" decoding="async" className="h-full w-full object-cover object-center" data-id="element-34" data-mp="no6pvjqr18nt" />
              </div>
              <div className="px-5 pb-6 pt-4" data-id="element-35" data-mp="3hgolfqd4thqi">
                <div className="flex flex-wrap items-center gap-2" data-id="element-36" data-mp="3ljl4fi6l3fuz">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-37" data-mp="3lke1tsjnkt0g">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-gold px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-ink" data-id="element-38" data-mp="2ttgel40220md">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 text-lg font-bold leading-snug text-white" data-id="element-39" data-mp="32s23dgw4ebvl">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-40" data-mp="37lwkqdo96eri">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}